export default __webpack_public_path__ + "static/media/Snd_P_Starts.2f534d88.mp3";